import { Schema } from "@effect/schema";
import { Record } from "effect";
import { pipe, satisfies } from "effect/Function";

export const WalletKey = Schema.Literal(
  "metaMask",
  "rabby",
  "coinbase",
  "safe",
  "walletConnect",
  "injected"
).annotations({ identifier: "WalletKey" });

export type WalletKey = typeof WalletKey.Type;
export const walletKeys = WalletKey.literals;
export const isWalletKey = Schema.is(WalletKey);

interface GenericWallet {
  label: string;
}

const baseWalletMap = satisfies<Record<WalletKey, GenericWallet>>()({
  metaMask: {
    label: "MetaMask",
  },
  rabby: {
    label: "Rabby",
  },
  coinbase: {
    label: "Coinbase Wallet",
  },
  safe: {
    label: "Safe",
  },
  walletConnect: {
    label: "WalletConnect",
  },
  injected: {
    label: "Injected",
  },
});

type WalletMap = {
  [K in keyof typeof baseWalletMap]: (typeof baseWalletMap)[K] & { key: K };
};

export const walletMap = pipe(
  baseWalletMap,
  Record.map((value, key) => ({ key, ...value }))
) as WalletMap;

export type Wallet = (typeof walletMap)[WalletKey];

export function getWallet(walletKey: WalletKey): Wallet {
  return walletMap[walletKey];
}

export interface WalletOption {
  walletKey: WalletKey;
  href: string | null;
}
